var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_8916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0923 5.09175C22.1192 4.7693 22.0027 4.45137 21.7739 4.22258C21.5451 3.99378 21.2272 3.87732 20.9047 3.90419L8.90475 4.90419C8.29933 4.95465 7.84945 5.48633 7.8999 6.09175C7.95035 6.69716 8.48203 7.14705 9.08745 7.0966L18.0815 6.34709L4.34076 19.9841C3.90956 20.412 3.90692 21.1085 4.33486 21.5397C4.76281 21.9709 5.45928 21.9735 5.89049 21.5456L19.6516 7.88842L18.8999 16.909C18.8494 17.5145 19.2993 18.0461 19.9047 18.0966C20.5102 18.147 21.0418 17.6972 21.0923 17.0917L22.0923 5.09175Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_8916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.9375 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/top-right-arrow.3cfb8df138df84237723344601ff327e.svg";
export { ForwardRef as ReactComponent };